<script>
export default {
  name: 'AppAlert',
  props: ['error'],
  data() {
    return {}
  },
  computed: {
    show() {
      return this.error.length
    },
  },
}
</script>

<template>
  <b-alert
    v-if="show"
    show
    variant="danger"
    aria-invalid="true"
  >
    <p>
      <strong>{{ error }}</strong>
    </p>
  </b-alert>
</template>
